import { render, staticRenderFns } from "./OrdersList.vue?vue&type=template&id=6fef8150&scoped=true"
import script from "./OrdersList.vue?vue&type=script&lang=js"
export * from "./OrdersList.vue?vue&type=script&lang=js"
import style0 from "./OrdersList.vue?vue&type=style&index=0&id=6fef8150&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fef8150",
  null
  
)

export default component.exports